<template>
  <v-dialog v-model="dialog" persistent :max-width="600">
    <v-card>
      <v-card-text>
        <v-img :src="'/static/img/assets/logo/MetaPay.png'" width="149px" class="img" />
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('detail') }"
              xs12
              sm12
              md12
            >
              <label
                ><b>{{ $t('Detail') }}</b></label
              >
              <input
                :data-vv-as="$t('Detail')"
                v-validate="'max:250|required'"
                name="detail"
                v-model="input.detail"
                type="text"
              />
              <!-- data-vv-as="Image" -->
              <span class="text-error" v-show="errors.has('detail')"
                >{{ errors.first('detail') }}
              </span> </v-flex
            ><br />
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('amount') }"
              xs12
              sm12
              md12
            >
              <label
                ><b>{{ $t('Amount') }}</b></label
              >
              <input
                name="amount"
                :data-vv-as="$t('Amount')"
               
                v-validate="'required|decimal:2|min_value:1'"
                v-model="input.amount"
                type="text"
              />
              <span class="text-error" v-show="errors.has('amount')"
                >{{ errors.first('amount') }}
              </span>
            </v-flex>
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('message') }"
              xs12
              sm12
              md12
            >
              <label
                ><b>{{ $t('note') }}</b></label
              >
              <AutoresizeTextarea
                v-validate="'max:500'"
                v-model="input.note"
                style="white-space: break-spaces"
                :data-vv-as="$t('note')"
                name="message"
              />
              <span class="text-error" v-show="errors.has('message')"
                >{{ errors.first('message') }}
              </span>
            </v-flex>

            <toggle-button
              class="mt-2"
              :value="input.is_create_order"
              :sync="true"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
              @change="toggleCreateOrder"
            />
            <label style="align-self: center; margin-top: 7px; margin-left: 10px;"
              ><b>{{ $t('สร้างออเดอร์') }}</b></label
            >
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline color="grey" flat @click="close">Close</v-btn>
        <v-btn v-if="input.create" depressed color="primary" @click="save">Save</v-btn>
        <v-btn v-else depressed color="primary" @click="update">Update</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: { Multiselect, AutoresizeTextarea, ToggleButton },
  props: ['value', 'valueMetaPay'],
  data() {
    return {
      dialog: this.value
    }
  },
  computed: {
    input() {
      return this.valueMetaPay
    }
  },
  methods: {
    toggleCreateOrder() {
      const vm = this
      vm.input.is_create_order = !vm.input.is_create_order
    },
    save() {
      const vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }

        vm.$emit('addIntentItem', 'meta_pay', vm.input)
        vm.close()
      })
    },
    update() {
      const vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          reject()
          return false
        }
        vm.$emit('updateMetaPaymentItem', vm.input)
        vm.close()
      })
    },
    close() {
      const vm = this
      vm.dialog = false
      vm.$emit('input', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/ModalMetaPay.vue